import { NODE_TYPE as NT } from 'shared/constants/slate';
import { keycodeFromEvent } from 'shared/helpers';


const getCurrentHeading = (value) => {
  const { startBlock } = value;

  return (startBlock && startBlock.type === NT.heading
    ? startBlock
    : null
  );
};


const onBackspace = (e, change, editor) => {
  const { value } = change;

  // Expanded state seems fine.
  if (value.isExpanded) return;

  const heading = getCurrentHeading(value);
  if (heading && heading.isEmpty) {
    e.preventDefault()
    return change.setBlock(NT.paragraph)
  }
};


const onEnter = (e, change, editor) => {
  // IMPORTANT!
  // This should swallow soft break if there is one configured
  // as long as it comes after this plugin!

  const { value } = change;

  const heading = getCurrentHeading(value);
  if (!heading || !heading.data.get('level')) {
    // Should always have 'level' though.
    return;
  }

  e.preventDefault();

  if (value.isExpanded) {
    // We do need to handle isExpanded situation,
    // because slate's default split behavior is at odd
    // with the inner block wrapping of heading.

    // Just keep it simple by deleting it falling it through
    // the rest logic below. So do not return change.
    change.delete();
  }

  // Hitting enter on empty heading should reset to paragraph and
  // split, resulting in TWO normal lines (one unset, plus one new)
  if (heading.text.length === 0) {
    return change
      .setBlock(NT.paragraph)
      .splitBlock()
  }

  const { selection: sel } = value;

  // Hitting enter at end of heading should split and unset,
  // resulting in a new normal line BELOW heading.
  if (sel.isAtEndOf(heading)) {
    return change.splitBlock().setBlock(NT.paragraph);
  }

  // Hitting enter at start of heading should split and unset,
  // result in a new normal line ABOVE heading.
  if (sel.isAtStartOf(heading)) {
    change.splitBlock();

    const { document: doc, startBlock } = change.value;
    const prevBlock = doc.getPreviousSibling(startBlock.key);
    if (prevBlock && prevBlock.type === NT.heading) {
      return change.setNodeByKey(prevBlock.key, NT.paragraph)
    }
  }

  // Hitting enter in middle of heading should just split normally.
  return change.splitBlock()
};


export const EditHeading = (opts = {}) => ({
  onKeyDown(e, change, editor) {
    const args = [e, change, editor];
    const { code, kc } = keycodeFromEvent(e);

    switch (code) {
      case kc.codes.enter: return onEnter(...args);
      case kc.codes.backspace: return onBackspace(...args);
      default: return;
    }
  },
});



// WEBPACK FOOTER //
// ./src/components/slate/plugins/EditHeading.js